import { TZDate } from '@date-fns/tz'
import { IconClockHour3 } from '@tabler/icons-react'
import { format } from 'date-fns'
import { ru } from 'date-fns/locale'
import React from 'react'
import s from './teacher-sell-card.module.scss'

export const NearestAppointment = ({nearest_available_time}) => {
	return (
		<div className={s.nearestAvailableTimeWrapper}>
			<IconClockHour3 className={s.nearestAvailableTimeIcon} />
			<span className={s.nearestAvailableTimeLabel}>
				Ближайшая запись{" "}
				<strong className={s.nearestAvailableTimeBold}>
					{format(
						new TZDate(
							nearest_available_time,
							Intl.DateTimeFormat().resolvedOptions().timeZone
						),
						"d MMMM в HH:mm",
						{ locale: ru }
					)}
				</strong>
			</span>
		</div>
	)
}
